import { FileSignature } from 'lucide-react'
import { TemplateLibrary } from './TemplateLibrary'

export function ContractsPage() {
  return (
    <TemplateLibrary
      model="pdf"
      icon={FileSignature}
      title="Contratti"
      description={
        <>
          Documenti legali mostrati in fase di acquisto e allegati alla prenotazione (condizioni di sosta, informative).
          Multilingua; le aree <span className="text-coal">evidenziate</span> sono variabili compilate per ogni cliente.
        </>
      }
      showSubject={false}
      unit="documento"
      unitPlural="Documenti"
      searchPlaceholder="Cerca documento…"
    />
  )
}
